'use strict';

const dialog = require('../../dialog'),
    toaster = require('../../toaster'),
    isMobileOrTabletWidth = require('../../modules/util/isMobileOrTabletWidth'),
    gtm = require('../../modules/google').tagManager;

const Urls = window.Urls || {};
let quantityBlock = {};
let $cache = {};
let removeProducts = false; //Default is false to prevent unintented request when the user makes an action except for 'Yes'

const dataLayer = window.dataLayer || [];
/**
* @Class quantityBlock
* Handle the increment and decrement function of the quantity block on Cart and Product page
*/
quantityBlock = {
    /**
    * @JSON object
    * Includes all default selectors and variables
    */
    def: {
        quantityField: 'js-quantity',
        quantityFieldOldVal: null,
        quantityFieldNewVal: null,
        incrementBtn: '.js-increment',
        decrementBtn: '.js-decrement',
        productObj: {}
    },

    /**
    * @function
    * Creates JSON object with jQuery objects
    */
    initializeCache: function () {
        $cache = {
            $cartTable: $('.js-shopping-cart', '#main'),
            $quantityField: $('.js-quantity', '#main'),
            $incrementBtn: $('.js-increment', '#main'),
            $decrementBtn: $('.js-decrement', '#main'),
            $cartSubmitForm: $('.js-cart-items-form'),
            $bonusProductRemovalPopupContainer: $('.js-free-product-removal')
        };
    },

    /**
    * @function
    * Model for increment functionality
    */
    increment: function () {
        const currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());

        if (isNaN(currentValue) || currentValue < 1) {
            quantityBlock.def.productObj.$inputField.val(1);

        } else if (parseInt(currentValue) >= 999) {
            quantityBlock.def.productObj.$inputField.val(999);

        } else {
            quantityBlock.def.productObj.$inputField.val(parseInt(currentValue) + 1);
        }

        let eventData = $('#line-item-increment-' + quantityBlock.def.productObj.productId).val();
        if (eventData) {
            eventData = JSON.parse(eventData);
        }
        gtm.updateQuantity('add_to_cart', eventData, Math.abs(quantityBlock.def.productObj.deltaQuantity));
        quantityBlock.updateCart();
        gtm.pushQuantityChange(true, quantityBlock.def.productObj.productId);
    },

    /**
    * @function
    * Model for decrement functionality
    */
    decrement: function () {
        let currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());

        if (isNaN(currentValue) || currentValue < 1) {
            quantityBlock.def.productObj.$inputField.val(0);
            currentValue = 1;

        } else {
            quantityBlock.def.productObj.$inputField.val(parseInt(currentValue) - 1);
        }

        quantityBlock.checkRemoveBonusProducts(quantityBlock.def.productObj.productId, quantityBlock.def.productObj.lineItemUUID, parseInt(quantityBlock.def.productObj.$inputField.val()), currentValue);
        let eventData = $('#line-item-' + quantityBlock.def.productObj.productId).val();
        if (eventData) {
            eventData = JSON.parse(eventData);
        }
        gtm.updateQuantity('remove_from_cart', eventData, Math.abs(quantityBlock.def.productObj.deltaQuantity));
        gtm.pushQuantityChange(false, quantityBlock.def.productObj.productId);
    },

    /**
    * @function
    * check if a bonus product will be removed by this action
    * @input productID: productID of the affected Product
    * @input lineItemUUID: UUID of the affected LineItem
    * @input newQuantity: new Quantity for the affected lineItem
    * @input currentQuantity: old Quantity for the affected lineItem
    * @output boolean of available products for single product
    */
    checkRemoveBonusProducts: function (productID, lineItemUUID, newQuantity, currentQuantity) {
        $.ajax({
            url: Urls.cartCheckRemoveBonusProducts,
            data: {
                pid: productID,
                uuid: lineItemUUID,
                newQuantity: newQuantity
            }
        })
            .fail(function (jqXHR, status, err) {
                console.error('Failure checking for removed bonus products: ', err);
            })
            .done(function (removedProductImages) {
                if (removedProductImages) {
                    //Get the dynamic header and description from the rendered template and place them in the correct place in the popup
                    const originHeaderDiv = $(removedProductImages).find('.js-removed-products-wrapper');
                    const originBodyDiv = $(removedProductImages).find('.js-removed-products-body');
                    const targetHeaderDiv = $('.js-custom-popup-header');
                    const targetBodyDiv = $('.js-custom-popup-body');
                    $(targetHeaderDiv).html($(originHeaderDiv).html());
                    $(targetBodyDiv).html($(originBodyDiv).html());
                    quantityBlock.createBonusWarningDialog(newQuantity, currentQuantity, removedProductImages);
                } else {
                    quantityBlock.getAvailability(quantityBlock.def.productObj.productId,
                        quantityBlock.def.productObj.bundledProducts,
                        quantityBlock.def.productObj.horProducts,
                        quantityBlock.def.productObj.elixirProducts,
                        quantityBlock.def.productObj.$inputField,
                        newQuantity === 0, (newQuantity - currentQuantity),
                        quantityBlock.def.productObj.dataLayerData);
                }
            });
    },

    /**
    * @function
    * Opens the 'these products will be removed' dialog for the current action
    * @input: currentQuantity {number} current quantity for product
    * @input currentQuantity: old Quantity for the affected lineItem
    * @input removedBonusProductImagesHtml: HTML with the images of the bonus products that will be removed if 'yes' is clicked
    */
    createBonusWarningDialog: function (newQuantity, currentQuantity, removedBonusProductImagesHtml) {
        removeProducts = false;

        $cache.$bonusProductRemovalPopupContainer.find('.js-free-product-removal-images').html(removedBonusProductImagesHtml);
        $cache.$bonusProductRemovalPopupContainer.find('.js-remove-popup-text').text(Resources.REMOVE_POPUP);

        if (isMobileOrTabletWidth()) {
            toaster.def.$toastContent.html($cache.$bonusProductRemovalPopupContainer.html());
            toaster.open({
                open: function() {
                    $('.js-modal-overlay').show();

                    $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(e){
                        removeProducts = true;
                        const giftLabelDiv = e.currentTarget.parentNode.parentNode.querySelector('.gift-label');
                        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;
                        gtm.pushGwpEvent('remove gift', giftName);
                        toaster.closeToasters();
                    });
                    $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                        removeProducts = false;
                        toaster.closeToasters();
                    });

                },
                close: bonusWarningClose.bind(this, newQuantity, currentQuantity)
            });
            return;
        }
        dialog.open({
            html: $cache.$bonusProductRemovalPopupContainer.html(),
            target: $('.js-bonus-product-dialog-wrapper'),
            options: {
                width: 600,
                dialogClass: 'bonus-dialog-content gwp-dialog',
                open: function() {
                    $('.js-modal-overlay').show();

                    $(document).off('click.popup', '.js-modal-overlay').on('click.popup', '.js-modal-overlay', function(){
                        dialog.close();
                    });

                    $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(e){
                        removeProducts = true;
                        const giftLabelDiv = e.currentTarget.parentNode.parentNode.querySelector('.gift-label');
                        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;
                        gtm.pushGwpEvent('remove gift', giftName);
                        dialog.close();
                    });
                    $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                        removeProducts = false;
                        dialog.close();
                    });

                },
                close: function () {
                    bonusWarningClose(newQuantity, currentQuantity);
                    dialog.close();
                    $('.js-modal-overlay').hide();
                }
            }
        });
    },

    /**
    * @function
    * Removing all quantity of a product line item
    */
    removeFullQuantity: function () {
        const currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());
        quantityBlock.def.productObj.$inputField.val(0);

        quantityBlock.checkRemoveBonusProducts(quantityBlock.def.productObj.productId, quantityBlock.def.productObj.lineItemUUID, parseInt(quantityBlock.def.productObj.$inputField.val()), currentValue);
    },

    /**
    * @function
    * Model for updating the input text field after change has been done
    */
    changeQuantityField: function () {
        let currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());

        if (isNaN(currentValue) || currentValue < 0) {
            quantityBlock.def.productObj.$inputField.val(0);
            currentValue = 0;

        } else if (parseInt(currentValue) >= 999) {
            quantityBlock.def.productObj.$inputField.val(999);
            currentValue = 999;
        }

        const oldValue = parseInt(quantityBlock.def.quantityFieldOldVal, 10);

        if (currentValue < oldValue) {
            quantityBlock.checkRemoveBonusProducts(quantityBlock.def.productObj.productId, quantityBlock.def.productObj.lineItemUUID, currentValue, oldValue, quantityBlock.def.productObj.dataLayerData);

            return;
        }
        const quantityDelta = currentValue - oldValue;

        if (currentValue === 0 && quantityDelta < 0) {
            gtm.updateQuantity('remove_from_cart', quantityBlock.def.productObj.dataLayerData, Math.abs(quantityBlock.def.productObj.deltaQuantity));
        }
        quantityBlock.updateCart();

    },

    /**
    * @function
    * Check inventory for available products quantity for single product
    * @input pid:numer, string - product ID, quantityInput: jQuery object of HTML input field containing the product quantity
    * @input removed: is this a removed event
    * @input deltaQuantity: how many products were effected by this event
    * @output number of available products for single product
    */
    getAvailability: function (pid, bundledProducts, horProducts, elixirProducts, quantityInput, removed, deltaQuantity, dataLayerData) {
        $.ajax({
            url: Urls.getAvailability,
            data: {
                pid: pid,
                Quantity: quantityInput.val()
            }
        })
            .fail(function () {
                console.log('fail');
            })
            .done(function (data) {
                // open popup and adjust quantity in input field to maximum available products
                if (data && data.availability && !data.availability.isAvailable && data.availability.statusQuantity > 0) {
                    quantityBlock.createDialog(data.availability.levels.IN_STOCK);
                } else {
                    // trigger gtm event
                    // trigger remove only when all product line items for a product
                    // are removed
                    if (removed && deltaQuantity < 0) {
                        gtm.updateQuantity('remove_from_cart', dataLayerData, Math.abs(deltaQuantity));
                    }
                    quantityBlock.updateCart();
                }

            });
    },

    /**
    * @function
    * Opens the 'not available' dialog with the current product
    * @input: {number} maximum available quantity for single product
    */
   createDialog: function () {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.MODAL_NOINVENTORY_HEADING
            },
            paragraphs: [
                {
                    text: window.Resources.MODAL_NOINVENTORY_MESSAGE
                }
            ],
            ctaHolder: {},
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.MODAL_NOINVENTORY_BUTTON_OK,
                    eventName: 'onPrimaryButtonClick',
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true
        });
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the product ID for the given input field ID
    */
    getProductID: function (ele) {
        const productIdArr = ele.attr('id').split('-');
        const productId = productIdArr[productIdArr.length - 1];
        return productId;
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the bundled products for the given input field ID
    */
    getBundledProducts: function (ele) {
        const bundledProducts = ele.data('bundled-products');
        return bundledProducts;
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the House of Rituals products for the given input field ID
    */
    getHORProducts: function (ele) {
        const horProducts = ele.data('hor-products');
        return horProducts;
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the elixir products for the given input field ID
    */
    getElixirProducts: function (ele) {
        const elixirProducts = ele.data('elixir-products');
        return elixirProducts;
    },

    /**
    * @function
    * @input: jQuery object of the clicked button
    * @output: the quantity input field object for the given object/button pressed
    */
    getInputField: function (ele) {
        const $inputField = ele.hasClass(quantityBlock.def.quantityField) ? ele : ele.siblings('.' + quantityBlock.def.quantityField);
        return $inputField;
    },

    /**
    * @function
    * @input: jQuery object of the table row
    * @output: the lineitem UUID for the given table row
    */
    getLineItemUUID: function (ele) {
        const lineItemUUID = ele.data('uuid');
        return lineItemUUID;
    },

    /**
    * @function
    * Creates/updates the object in default global scope for single product
    * @input: jQuery object of the clicked button
    */
    buildObj: function (ele) {
        const obj = {};
        obj.$inputField = quantityBlock.getInputField(ele);
        obj.productId = quantityBlock.getProductID(obj.$inputField);
        obj.bundledProducts = quantityBlock.getBundledProducts(obj.$inputField);
        obj.horProducts = quantityBlock.getHORProducts(obj.$inputField);
        obj.elixirProducts = quantityBlock.getElixirProducts(obj.$inputField);
        const cartLineItemElement = obj.$inputField.parents('.js-cart-row').first();
        obj.lineItemUUID = quantityBlock.getLineItemUUID(cartLineItemElement);
        const dataLayerData = cartLineItemElement.find('#line-item-' + obj.productId).val();
        obj.dataLayerData = dataLayerData && JSON.parse(dataLayerData);
        // add this object also to class scope
        quantityBlock.def.productObj = obj;
    },

    /**
    * @function
    * Update Cart after events functions
    */
    updateCart: function () {
        $cache.$cartSubmitForm.submit();
    },

    /**
    * @function
    * Function for initializing all the events for the quantity block
    */
    events: function () {

        /* CART-PAGE: DECREMENT EVENT */
        $(document).on('click', quantityBlock.def.decrementBtn, function (e) {
            e.preventDefault();
            quantityBlock.decrement(quantityBlock.buildObj($(this)));
        });

        /* CART-PAGE: INCREMENT EVENT */
        $(document).on('click', quantityBlock.def.incrementBtn, function (e) {
            e.preventDefault();
            quantityBlock.increment(quantityBlock.buildObj($(this)));
        });

        /* CART-PAGE: INPUT FIELD EVENT */
        $(document).on('blur', '.js-quantity', function (e) {
            e.preventDefault();

            // don't do anything when the value didn't changed from last time
            if ($(this).val() === quantityBlock.def.quantityFieldOldVal) {
                return;
            }

            quantityBlock.changeQuantityField(quantityBlock.buildObj($(this)));
        });

        /* CART-PAGE: INPUT FIELD EVENT - save old value on focus */
        $(document).on('focus', '.js-quantity', function (e) {
            e.preventDefault();

            quantityBlock.def.quantityFieldOldVal = $(this).val();
        });

        // trigger events on enter
        $(document).on('keyup keypress', '.js-quantity', function (e) {
            const keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                $(this).trigger('blur');
            }
        });
    },

    /**
    * @function
    * Main initializing function prepared as the only one for export as a module
    */
    init: function () {
        quantityBlock.initializeCache();

        // do not initialize when qunatity block is not present in view
        if ($cache.$quantityField.length <= 0) {
            return;
        }

        quantityBlock.events();
    }
};

module.exports = quantityBlock;

function bonusWarningClose(newQuantity, currentQuantity){
    $(document).trigger('resetPopupDialog');
    if (removeProducts) {
        quantityBlock.getAvailability(quantityBlock.def.productObj.productId,
            quantityBlock.def.productObj.bundledProducts,
            null,
            null,
            quantityBlock.def.productObj.$inputField,
            newQuantity === 0, (newQuantity - currentQuantity),
            quantityBlock.def.productObj.dataLayerData);

            const tierStep = $('.js-gwp-tier-step').val();
            if (tierStep > 0){
                dataLayer.push({
                    'event': 'GWPPopUpDelete',
                    'threshold': tierStep
                });
            }
    } else {
        quantityBlock.def.productObj.$inputField.val(currentQuantity);
    }
    $('.js-modal-overlay').hide();
}
